import { Component, OnInit, Inject } from "@angular/core";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ClientService } from "src/app/services/client.service";
import { TaxpayerType } from "src/app/model/taxpayer-type";
import { CustomerIibbResponsibility } from "src/app/model/client/client-edit";
import { AliquotTax } from "src/app/model/aliquot-tax";

@Component({
  selector: "client-edit-dialog",
  templateUrl: "client-edit-dialog.component.html",
  styleUrls: ["./client-edit-dialog.component.css"],
})
export class ClientEditDialogComponent implements OnInit {
  loading: boolean;
  taxpayerTypes: TaxpayerType[] = [];
  customerIibbResponsibilities: CustomerIibbResponsibility[] = [];
  aliquotTaxs: AliquotTax[] = [];
  form: FormGroup;
  loadingAction: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private clientService: ClientService,
    private notificationToastService: NotificationToastService,
    public dialogRef: MatDialogRef<ClientEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.formBuilder.group({
      BusinessName: [null, [Validators.required]],
      TaxId: [null, [Validators.required]],
      taxpayerType: [null, [Validators.required]],
      PrimaryPhone: [null, [Validators.required]],
      Email: [null, [Validators.required, Validators.email]],
      IibbResponsibility: [null],
      AliquotTax: [null],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  get f() {
    return this.form.controls;
  }

  async save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    try {
      this.loadingAction = true;
      const id = await this.clientService.update({
        BusinessName: this.form.value.BusinessName,
        TaxId: this.form.value.TaxId,
        TaxpayerTypeId: this.form.value.taxpayerType.Id,
        PrimaryPhone: this.form.value.PrimaryPhone,
        Email: this.form.value.Email,
        Id: null,

        Referrer: false,
        Code: null,
        Deleted: false,

        DocumentStreet: ' ',
        DocumentApartment: ' ',
        DocumentCityId: null,
        DocumentNumber: ' ',
        DocumentCountryId: null,
        DocumentFloor: ' ',
        DocumentStateId: null,
        DocumentPostalCode: ' ',

        AddressStreet: ' ',
        AddressApartment: ' ',
        AddressCityId: null,
        AddressNumber: ' ',
        AddressCountryId: null,
        AddressFloor: ' ',
        AddressStateId:  null,
        AddressPostalCode: ' ',

        PaymentConditionId: null,

        FceAmount: null,

        Notes: null,
        RelevanceId: null,

        SecondaryPhone: null,

        ErpCode: null,
        ProviderNumber: null,

        IsEntity: false,
        IsCashier: true,

        IibbResponsibilityId: this.form.value.IibbResponsibility.Id,
        IibbTaxRateId: this.form.value.AliquotTax.Id,
      });

      const cliente = await this.clientService.getClientSearch(id);
      this.dialogRef.close(cliente);
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Clientes"
      );
    } finally {
      this.loadingAction = false;
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      const edit = await this.clientService.getClientEdit();
      this.taxpayerTypes = edit.TaxpayerTypes;
      this.customerIibbResponsibilities = edit.CustomerIibbResponsibilities;
      this.aliquotTaxs = edit.AliquotTaxs;
      console.log(edit);
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Clientes"
      );
    } finally {
      this.loading = false;
    }
  }
}
